import React, { memo } from 'react';

import AttachedFileItem
  from '../../../../components/AttachedFileItem/AttachedFileItem';
import CustomReadMoreContent
  from '../../../../components/CustomReadMoreText/CustomReadMoreContent';
import { downloadFileWithProgress } from '../../../../shared/fileUtils';
import {
  ITQServiceRequestDetails,
  ITQServiceRequestResponsesResult,
  TQServiceRequestTypeValue,
} from '../../../../types/tqConnectTypes/service-requests';
import ServiceRequestCardStats
  from '../../components/TQServiceRequestResponseBottpmSheet/ServiceRequestCardStats';
import ServiceOfferButton from './ServiceOfferButton';

interface Props {
  serviceRequestDetails: ITQServiceRequestDetails;
  cameFrom: TQServiceRequestTypeValue;
  setOpenTQServiceRequestResponseBottpmSheet: (open: boolean) => void;
  serviceRequestResponsesResult: ITQServiceRequestResponsesResult;
}

const ServiceRequest: React.FC<Props> = ({
  serviceRequestDetails,
  cameFrom,
  setOpenTQServiceRequestResponseBottpmSheet,
}) => {
  const {
    requestedBy,
    totalResponses,
    status,
    createdAt,
    requestedTo,
    description,
    tags,
    visibility,
    attachments,
  } = serviceRequestDetails;

  return (
    <div className="service-request request__content">
      <ServiceRequestCardStats
        requestedBy={requestedBy}
        requestedTo={visibility === 'private' ? requestedTo : undefined}
        totalResponses={totalResponses}
        status={status}
        createdAt={createdAt}
        visibility={cameFrom === 'discover' ? undefined : visibility}
        insideDetailsPage
      />
      {visibility === 'public' && totalResponses > 0 ? (
        <div className="service-request__offer-button">
          <ServiceOfferButton
            count={totalResponses}
            onClick={() => {
              setOpenTQServiceRequestResponseBottpmSheet(true);
            }}
          />
        </div>
      ) : null}

      <CustomReadMoreContent
        formatType="parsed"
        lines={5}
        className="content__description">
        {description}
      </CustomReadMoreContent>

      {attachments?.length ? (
        <div className="content__attachments">
          {attachments.map((attachment) => (
            <AttachedFileItem
              key={attachment.url}
              fileName={attachment.name}
              fileSize={attachment.size}
              fileExtension={attachment.type}
              onDownload={() => {
                downloadFileWithProgress(attachment.url, attachment.name);
              }}
            />
          ))}
        </div>
      ) : null}

      <br />

      {tags.length > 0 && (
        <div className="tq-service-card__tags" role="list">
          {tags.map((tag) => (
            <span
              key={tag._id}
              className="tq-service-card__tag"
              role="listitem">
              {tag.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(ServiceRequest);
